
import "core-js/stable";
import "regenerator-runtime/runtime";
/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import * as React from 'react';
import { store } from '@ice/stark-data';
import { IAppConfig, runApp } from 'ice';
import { ConfigProvider } from '@alifd/next';
import LzMessage from '@/components/common/LzMessage';
import PageLoading from '@/components/PageLoading';
import FrameworkLayout from '@/layouts/FrameworkLayout';
import { CommonService, requestConfig } from '@/service';
import AppManager from '@/AppManager';
import Cookie from 'js-cookie';
import NotFound from '@/components/NotFound';
import ErrorComponent from '@/components/ErrorComponent';

store.set('SYS_PROD', 'dy_cjyx'); // 设置系统类型 dy_cjyx-抖店

if (process.env.NODE_ENV === 'development') {
  // Cookie.set('shopId', 13057269); // 伊利
  // Cookie.set('shopId', 129950484);
  // Cookie.set('shopId', 36271825);
  Cookie.set('shopId', 7240988); // 金领冠
}

const appConfig: IAppConfig = {
  app: {
    rootId: 'icestark-container',
    addProvider: ({ children }) => (
      <ConfigProvider prefix="lz-cjyx-">{children}</ConfigProvider>
    ),
  },
  router: {
    type: 'browser',
    basename: '/web',
    fallback: <div>页面加载中...</div>,
  },
  request: requestConfig,
  parseSearchParams: true,
  icestark: {
    type: 'framework',
    Layout: FrameworkLayout,
    getApps: AppManager.getApps,
    appRouter: {
      LoadingComponent: PageLoading,
      NotFoundComponent: NotFound,
      ErrorComponent,
    },
  },
};

// 定时刷新SSOToken 由于首页有部分接口需要token信息，所以等请求成功后再渲染页面，之所以不把create方法放进getSSOToken()里，是因为这样每隔30分钟就会刷新一次页面，有可能导致用户的操作中断
const getSSOToken = () => CommonService.getSSOToken({
  shopId: Cookie.get('shopId'),
}).then((res) => {
  if (res.data) {
    sessionStorage.setItem('LZ_SSO_TOKEN', res.data);
  } else {
    LzMessage.error('获取商家信息失败，请重新登录', '');
  }
}).catch((e) => {
  LzMessage.error('获取商家信息失败，请重新登录', '');
});

const singleGetToken = () => CommonService.getSSOToken({
  shopId: Cookie.get('shopId'),
}).then((res) => {
  if (res.data) {
    sessionStorage.setItem('LZ_SSO_TOKEN', res.data);
    runApp(appConfig);
    setInterval(getSSOToken, 30 * 60 * 1000);
  } else {
    LzMessage.error('获取商家信息失败，请重新登录', '');
  }
}).catch((e) => {
  LzMessage.error('获取商家信息失败，请重新登录', '');
});

singleGetToken();

  